var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "530px",
    height: "274px",
    viewBox: "0 0 530 274",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M257.917602,111.831421 C257.633475,89.4302443 277.881268,76.9286529 293.134406,69.4964866 C308.806258,61.8699177 314.070086,56.9799411 314.010269,50.1608912 C313.890637,39.7229595 301.508678,35.1171101 289.919284,34.9376614 C269.701399,34.6236262 257.94751,40.3958921 248.601225,44.7624767 L241.318599,10.6821812 C250.694793,6.36045883 268.056453,2.59203651 286.061137,2.42754189 C328.321302,2.42754189 355.971353,23.2884511 356.120893,55.634076 C356.285388,96.6829619 299.34034,98.9559785 299.729145,117.304606 C299.863732,122.867515 305.172422,128.804276 316.806678,130.314636 C322.56399,131.077293 338.460152,131.660501 356.479791,123.360999 L363.55306,156.334694 C353.862831,159.863852 341.406101,163.243469 325.898745,163.243469 C286.120953,163.243469 258.141913,142.098432 257.917602,111.831421 M431.519248,160.402198 C423.802954,160.402198 417.29794,155.901027 414.396853,148.992253 L354.027325,4.85009909 L396.257582,4.85009909 L404.661762,28.0737493 L456.268212,28.0737493 L461.143234,4.85009909 L498.363882,4.85009909 L465.88367,160.402198 L431.519248,160.402198 M437.4261,118.381298 L449.613656,59.9707525 L416.236202,59.9707525 L437.4261,118.381298 M206.714912,160.402198 L173.427181,4.85009909 L213.668548,4.85009909 L246.941325,160.402198 L206.714912,160.402198 M147.182812,160.402198 L105.296499,54.5274758 L88.3535523,144.550898 C86.3646627,154.600024 78.5137829,160.402198 69.7955678,160.402198 L1.32094168,160.402198 L0.363882049,155.886073 C14.4206954,152.835445 30.3916281,147.91556 40.0669029,142.651733 C45.9887093,139.43661 47.6785178,136.625248 49.6225451,128.983725 L81.713951,4.85009909 L124.243289,4.85009909 L189.442976,160.402198 L147.182812,160.402198",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "16.1481739%",
    y1: "34.4008407%",
    x2: "85.8318643%",
    y2: "66.3485849%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#254AA5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "visa"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 530,
    height: 274
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10267",
    transform: "translate(259.870397, 134.996157) scale(-1, 1) rotate(-180.000000) translate(-259.870397, -134.996157) translate(10.636117, 52.748844)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10269-Clipped"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "path10273"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g10269",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-54.831542, -164.494625)",
    id: "g10275"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.045643, 4.466278)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "path10283",
    fill: "url(#linearGradient-3)",
    fillRule: "nonzero",
    points: "0 304.065822 490.677496 484.770644 602.304546 181.656897 111.632034 0.95207495"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.d665511d70a7831101d56f08dd16e5c8.svg";
export { ForwardRef as ReactComponent };